<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHandle from "../DesignerQuestionHardwareHandle.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHandle,
            SynsealTileQuestion
        ],
    }
</script>
